<div class="wrapper">
  @if (mode === 'detail') {
    <!-- MODE B — the record. Moved here from the site's Daily diary tab, which
         no longer exists: diaries live on the project page only. -->
    <!-- Same 711px column the Daily report tab's record occupies. The project
         page is far wider than the site page this moved from, so without it
         the day card and its section cards stretch the whole width. -->
    <div class="detail-mode flex flex-col gap-[20px] w-[711px] max-w-full">
      <div class="back-row">
        <button (click)="backToList()" class="back-link text-type-10" type="button">
          <mat-icon>arrow_back</mat-icon>
          All diaries
        </button>
      </div>
      <app-horizontal-date-picker
        (onDateSelection)="handleDateChange($event)"
        [count]="9"
        [date]="date"
        [triggerChange]="triggerDateChange"
      />
      <app-daily-diary-day
        [date]="date"
        [projectId]="projectId"
        [siteId]="detailSiteId"
      />
    </div>
  } @else if (loading && !diaries.length) {
    <div class="no-data text-type-8 mt-[40px]">Loading…</div>
  } @else if (diaries.length) {
    <!-- MODE A — every diary on the project, grouped per site exactly like the
         Daily reports tab's panels: heading with a count, a grid collapsed to
         one row, and a See more toggle. -->
    @for (group of groups; track group.siteId) {
      <div class="site-panel">
        <div class="text-type-4 mb-[12px]">
          {{ group.siteName }} ({{ group.rows.length }}
          diar{{ group.rows.length === 1 ? 'y' : 'ies' }})
        </div>
        <div [class.collapsed]="!expanded[group.siteId]" class="diaries-list">
          @for (row of group.rows; track row.id || row.uuid) {
            <div
              (click)="openDiary(row)"
              [class]="row?.status"
              class="diary-card"
              data-testid="project-diary-card"
            >
              <div class="name text-type-5">
                @if (row?.createdBy) {
                  {{ row.createdBy.first_name }} {{ row.createdBy.last_name }}
                } @else {
                  &mdash;
                }
              </div>
              <div class="filed-on text-type-10">
                {{ row?.diary_date | date:'MMMM d, y' }}
              </div>
              <div class="status text-type-10">
                {{ statusLabels[row?.status] || row?.status }}
                &middot;
                {{ remarkCount(row) }} remark{{ remarkCount(row) === 1 ? '' : 's' }}
                @if (!row?.contractor_working) {
                  &middot; contractor not working
                }
              </div>
            </div>
          }
        </div>
        @if (group.rows.length > 3) {
          <div (click)="toggleExpanded(group.siteId)" class="see-more text-type-9 flex">
            {{ expanded[group.siteId] ? 'See less' : 'See more' }}
          </div>
        }
      </div>
    }
  } @else {
    <div class="no-data text-type-8 mt-[80px]">No diaries on this project.</div>
  }
</div>
